import { defineStore } from 'pinia'
import { useStore } from '@/stores/index'

const defaultItem = {
  id: 0,
  detailId: 0,
  title: '',
  shopName: '',
  openDate: '',
  closeDate: '',
  imageCount: 0,
  images: [],
  advertisements: [],
  productGroups: [],
}

const getDateSystem = (periodStart, periodEnd) => {
  const periodStartStr = FORMATTEDDATE(periodStart, {
    dayWeekLess: true,
  })
  const periodEndStr = FORMATTEDDATE(periodEnd, {
    dayWeekLess: true,
  })

  const date =
    periodStartStr === periodEndStr
      ? [periodEndStr]
      : [periodStartStr, periodEndStr]

  return {
    date,
  }
}

export const usePreviewStore = defineStore('preview', {
  state: () => ({
    item: defaultItem
  }),

  getters: {
    previewFlyer: (state) => {
      if (0 in state.item) return []
  
      const { date } = getDateSystem(state.item.openDate, state.item.closeDate)
  
      const item = {
        id: state.item.id,
        shopName: state.item.shopName,
        detailId: state.item.detailId,
        issue: null,
        image: state.item.images[0]?.thumb_image_url,
        date: {
          date,
          type: 1 in date ? '' : 'limit',
        },
      }
  
      return [item]
    },
    spImages: (state) => {
      return state.item.images.map(item => {
        return {
          image: item.sp_image_url,
          width: item.sp_image_width,
          height: item.sp_image_height,
        }
      })
    },
    pcImages: (state) => {
      return state.item.images.map(item => {
        return {
          image: item.pc_image_url,
          width: item.pc_image_width,
          height: item.pc_image_height,
        }
      })
    },
    expirationDate:(state) => {
      return state.item.expire
    },
  },

  actions: {
    async fetchPreviewItem({ token, id, detailId }) {
      const rootStore = useStore()
      const runtimeConfig = useRuntimeConfig()
      await POST('get_preview_flyer_detail', {
        body: {
          clientKey: runtimeConfig.public.clientKey,
          token,
          id,
          detailId,
          // noAdvertisements: 1,
          reqTime: UNIXTIMESTAMP(),
        },
      })
        .then(res => {
          const item = res.data
          this.item = item
        })
        .catch(err => {
          const status = err.status
          const error = err.data.error.errorCode
          // アクセストークンが期限切れ
          if (status === 401 && error === '10001') {
            rootStore.refreshTokens(null)
          } else {
            return Promise.reject(err)
          }
        })
    },
  }
})